module.exports = __webpack_public_path__ + "img/logo-160x60.147ff9c4.png";